import React from 'react';
import {Chip} from '@mui/material';
import {getProvenanceChipColor} from '../../features/products/reportEditorPage/leftPanel/components/sourcesProvenance';

/**
 * The single "where did this come from" badge for Source Package items — federated search
 * results, saved Source Package tray items, and margin-rail citations all render this exact
 * markup so a given provenance kind (Corpus / My Data / Reports / Highlight / Shared by … /
 * Uploaded by …) always looks the same: same chip size, same filled-only-for-corpus rule, same
 * color palette (driven by {@link getProvenanceChipColor}).
 *
 * @param {{kind: string, primary: string}} provenance shape from getProvenanceDisplay /
 *   getProvenanceFromDocSourceType in sourcesProvenance.js
 */
export default function SourceProvenanceChip({provenance}) {
    if (!provenance) {
        return null;
    }
    return (
        <Chip
            size="small"
            label={provenance.primary}
            color={getProvenanceChipColor(provenance.kind)}
            variant={provenance.kind === 'corpus' ? 'filled' : 'outlined'}
        />
    );
}
